import React from 'react';


/* ── Icons ── */
const PhoneIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#1F7EF6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8a19.79 19.79 0 01-3.07-8.67A2 2 0 012 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16z" />
  </svg>
);
const MailIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#1F7EF6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
    <polyline points="22,6 12,13 2,6" />
  </svg>
);
const MapPinIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="#1F7EF6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);
const FbSvg = () => (<svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" /></svg>);
const LiSvg = () => (<svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z" /><circle cx="4" cy="4" r="2" /></svg>);
const IgSvg = () => (<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5" /><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z" /><line x1="17.5" y1="6.5" x2="17.51" y2="6.5" /></svg>);

const QUICK_LINKS = [
  { label: 'Home', href: '/' },
  { label: 'About Us', href: '/about' },
  { label: 'Services', href: '/service' },
  { label: 'Technologies', href: '/techno' },
  { label: 'Gallery', href: '/gallery' },
  { label: 'Contact Us', href: '/contact' },
];

export default function Footer() {
  return (
    <footer className="gx-footer">
      <div className="gx-main">

        {/* ── Col 1 : Brand ── */}
        <div className="gx-col">
          <div className="gx-brand-top">
            <img
              src="/assets/img/GalaxyErplogo.png"
              alt="GalaxyERP Logo"
              className="gx-logo-img"
            />
            <div className="gx-brand-title">
              <h2>GalaxyERP Software</h2>
              <p>Pvt. Ltd.</p>
            </div>
          </div>

          <p className="gx-brand-desc">
            We provide the best ERP software solutions to streamline your business
            processes. Empowering your business with technology for growth and
            efficiency. Transform your enterprise with our innovative solutions.
          </p>

          <h4 className="gx-col-head gx-head-gap">Office Numbers</h4>
          <div className="gx-rows">
            <div className="gx-row">
              <div className="gx-row-icon"><PhoneIcon /></div>
              <span className="gx-row-val"><a href="tel:+919638177750">+91-9638177750</a></span>
            </div>
            <div className="gx-row">
              <div className="gx-row-icon"><PhoneIcon /></div>
              <span className="gx-row-val"><a href="tel:+918128061833">+91-8128061833</a></span>
            </div>
          </div>
        </div>

        {/* ── Col 2 : Quick Links ── */}
        <div className="gx-col">
          <h4 className="gx-col-head">Quick Links</h4>
          <ul className="gx-links">
            {QUICK_LINKS.map(({ label, href }) => (
              <li key={label}><a href={href}>{label}</a></li>
            ))}
          </ul>
        </div>

        {/* ── Col 3 : Visit Us ── */}
        <div className="gx-col">
          <h4 className="gx-col-head">Visit Us</h4>
          <div className="gx-address-card">
            <div className="gx-addr-pin"><MapPinIcon /></div>
            <p className="gx-addr-text">
              410, The Boulevard, Pratham Circle,<br />
              Opp Pal RTO, Pal, Green City Rd,<br />
              Adajan, Surat, Gujarat – 395009
            </p>
          </div>
          <h4 className="gx-col-head gx-head-gap">Business Enquiry </h4>
          <div className="gx-rows">
            <div className="gx-row">
              <div className="gx-row-icon"><PhoneIcon /></div>
              <span className="gx-row-val"><a href="tel:+919924577750">+91-9924577750</a></span>
            </div>
            <div className="gx-row">
              <div className="gx-row-icon"><MailIcon /></div>
              <span className="gx-row-val"><a

                href="mailto:sales@galaxyerpsoftware.com"
                onClick={(e) => {
                  e.preventDefault();
                  window.open(
                    'https://mail.google.com/mail/?view=cm&to=sales@galaxyerpsoftware.com',
                    '_blank'
                  );
                }}
              >
               sales@galaxyerpsoftware.com
              </a>
              </span>
            </div>
          </div>
        </div>

      </div>

      {/* ── Bottom Bar ── */}
      <div className="gx-bottom">
        <p className="gx-copyright">
          © {new Date().getFullYear()} GalaxyERP Software Pvt. Ltd. All Rights Reserved.
        </p>
        <div className="gx-socials-wrap">
          <span className="gx-follow-lbl">Follow Us</span>
          <div className="gx-socials">
            <a href="https://www.facebook.com/people/Galaxy-ERP/61557637277831/" target="_blank" rel="noopener noreferrer" className="gx-social fb" aria-label="Facebook"><FbSvg /></a>
            <a href="https://www.linkedin.com/company/galaxy-erp-software-private-limited/" target="_blank" rel="noopener noreferrer" className="gx-social li" aria-label="LinkedIn"><LiSvg /></a>
            <a href="https://www.instagram.com/galaxyerpsoftwarepvtltd/" target="_blank" rel="noopener noreferrer" className="gx-social ig" aria-label="Instagram"><IgSvg /></a>
          </div>
        </div>
      </div>
    </footer>
  );
}